export default __webpack_public_path__ + "static/media/sms.5ef9b767.mp3";